
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"14","height":"14","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M7.964 2.982a.982.982 0 11-1.964 0 .982.982 0 011.964 0zM7.964 6.946a.982.982 0 11-1.964 0 .982.982 0 011.964 0zM7.964 10.91a.982.982 0 11-1.964 0 .982.982 0 011.964 0z","fill":"#58697D"}})])
          )
        }
      }
    